import { DefaultPushNotificationParser, PushNotificationParser } from './PushNotifications';

const parser: PushNotificationParser = {
  hrUpdated: DefaultPushNotificationParser.hrUpdated,
  other: DefaultPushNotificationParser.other,
  chatUpdated: DefaultPushNotificationParser.chatUpdated,
  joinTelemedicine: DefaultPushNotificationParser.joinTelemedicine,
  appointmentUpdated: DefaultPushNotificationParser.appointmentUpdated,
  medicationReminder: DefaultPushNotificationParser.medicationReminder,
};

export default parser;
